import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createPhraseByPlantelService,
  createPlantelService,
  createTalentByPlantelService,
  getPhraseByPlantelById,
  getPhrasesByPlantelService,
  getPlantelByIdService,
  getPlantelsService,
  getResponsePhraseByIdService,
  getResponsePhrasesByPlantelService,
  getTalentByPlantelById,
  getTalentsByPlantelService,
  getTalentsSelectorByPlantelService,
  togglePhraseActiveService,
  togglePlantelActiveService,
  toggleTalentActiveService,
  updatePlantelService,
  updateResponsePhraseService,
  updateTalentByPlantelById,
} from "../../../services/plantels/plantel.service";

export const getPlantelsThunk = createAsyncThunk(
  "plantels/getAll",
  async ({ page = 1, search = "" } = {}, { rejectWithValue }) => {
    try {
      return await getPlantelsService(page, search);
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener planteles";

      return rejectWithValue(message);
    }
  },
);

export const createPlantelThunk = createAsyncThunk(
  "plantels/create",
  async (payload, { rejectWithValue }) => {
    try {
      return await createPlantelService(payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al crear plantel";

      return rejectWithValue(message);
    }
  },
);

export const getPlantelByIdThunk = createAsyncThunk(
  "plantels/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getPlantelByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener plantel";

      return rejectWithValue(message);
    }
  },
);

export const updatePlantelThunk = createAsyncThunk(
  "plantels/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updatePlantelService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar plantel";

      return rejectWithValue(message);
    }
  },
);

export const togglePlantelActiveThunk = createAsyncThunk(
  "plantels/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await togglePlantelActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado";

      return rejectWithValue(message);
    }
  },
);

export const getTalentsByPlantelThunk = createAsyncThunk(
  "talents/getByPlantel",
  async ({ plantelId, page = 1 }, { rejectWithValue }) => {
    try {
      return await getTalentsByPlantelService(plantelId, page);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener talentos por plantel";

      return rejectWithValue(message);
    }
  },
);

export const createTalentByPlantelThunk = createAsyncThunk(
  "talents/create",
  async (payload, { rejectWithValue }) => {
    try {
      return await createTalentByPlantelService(payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al crear talento";

      return rejectWithValue(message);
    }
  },
);

export const getTalentByplantelByIdThunk = createAsyncThunk(
  "talents/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getTalentByPlantelById(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener talento";

      return rejectWithValue(message);
    }
  },
);

export const updateTalentByPlantelThunk = createAsyncThunk(
  "talents/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateTalentByPlantelById(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar talento";

      return rejectWithValue(message);
    }
  },
);

export const toggleTalentActiveThunk = createAsyncThunk(
  "talents/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleTalentActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado del talento";

      return rejectWithValue(message);
    }
  },
);

export const getFrasesByPlantelThunk = createAsyncThunk(
  "frases/getByPlantel",
  async (filters, { rejectWithValue }) => {
    try {
      return await getPhrasesByPlantelService(filters);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frases";

      return rejectWithValue(message);
    }
  },
);

export const getTalentsSelectorByPlantelThunk = createAsyncThunk(
  "talents/getSelectorByPlantel",
  async (plantelId, { rejectWithValue }) => {
    try {
      return await getTalentsSelectorByPlantelService(plantelId);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener talentos selector";

      return rejectWithValue(message);
    }
  },
);

export const createPhraseByPlantelThunk = createAsyncThunk(
  "frases/create",
  async (payload, { rejectWithValue }) => {
    try {
      return await createPhraseByPlantelService(payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al crear frase";

      return rejectWithValue(message);
    }
  },
);

export const getPhraseByPlantelByIdThunk = createAsyncThunk(
  "frases/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getPhraseByPlantelById(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frase";

      return rejectWithValue(message);
    }
  },
);

export const togglePhraseActiveThunk = createAsyncThunk(
  "frases/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await togglePhraseActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado de la frase";

      return rejectWithValue(message);
    }
  },
);

export const getResponsePhrasesByPlantelThunk = createAsyncThunk(
  "responsePhrases/getByPlantel",
  async (plantelId, { rejectWithValue }) => {
    try {
      return await getResponsePhrasesByPlantelService(plantelId);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frases de respuesta";

      return rejectWithValue(message);
    }
  },
);

export const getResponsePhraseByIdThunk = createAsyncThunk(
  "responsePhrases/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getResponsePhraseByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frase de respuesta";

      return rejectWithValue(message);
    }
  },
);

export const updateResponsePhraseThunk = createAsyncThunk(
  "responsePhrases/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateResponsePhraseService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar frase";

      return rejectWithValue(message);
    }
  },
);
